"use strict";

exports.__esModule = true;
exports.VARIANT = exports.SIZE = exports.ICON_SIZE = void 0;

var _styles = require("../styles");

var ICON_SIZE = {
  small: 'medium',
  medium: 'medium',
  large: (0, _styles.pxToEm)(24),
  jumbo: (0, _styles.pxToEm)(24)
};
exports.ICON_SIZE = ICON_SIZE;
var SIZE = {
  small: 'small',
  medium: 'medium',
  large: 'large',
  jumbo: 'jumbo'
};
exports.SIZE = SIZE;
var VARIANT = {
  danger: 'danger',
  success: 'success',
  warning: 'warning'
};
exports.VARIANT = VARIANT;